(function () {
  var config = window.BoostSDBadgesConfig;
  if (!config) return;

  var productByHandle = {};
  var feedLoaded = false;
  var feedLoading = null;

  function fetchFeed() {
    if (feedLoading) return feedLoading;
    var qs = new URLSearchParams(window.location.search);
    var query = qs.get('q') || '';
    var url = '/search?view=bss.product.labels&q=' + encodeURIComponent(query);
    feedLoading = fetch(url, { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (items) {
        items.forEach(function (item) {
          productByHandle[item.handle] = item;
        });
        feedLoaded = true;
      })
      .catch(function () { feedLoaded = true; });
    return feedLoading;
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function buildBadgesHtml(item) {
    var parts = [];
    var handles = item.collection_handles || [];
    if (config.blueTouch.enabled && handles.indexOf(config.blueTouch.handle) !== -1) {
      parts.push('<span class="badge badge--blue-touch">' + escapeHtml(config.blueTouch.text) + '</span>');
    }
    if (config.bestSeller.enabled && handles.indexOf(config.bestSeller.handle) !== -1) {
      parts.push('<span class="badge badge--best-seller">' + escapeHtml(config.bestSeller.text) + '</span>');
    }
    if (config.fastIn.enabled && handles.indexOf(config.fastIn.handle) !== -1) {
      parts.push('<span class="badge badge--fast-in">' + escapeHtml(config.fastIn.text) + '</span>');
    }
    if (!parts.length) return '';
    return '<div class="boost-sd-custom-badges badge-list">' + parts.join('') + '</div>';
  }

  function getHandleFromCard(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  function injectBadges(card) {
    if (card.dataset.bssBadgesInjected === '1') return;
    if (card.querySelector('.boost-sd-custom-badges')) {
      card.dataset.bssBadgesInjected = '1';
      return;
    }
    var handle = getHandleFromCard(card);
    if (!handle) return;
    var item = productByHandle[handle];
    if (!item) return;
    var html = buildBadgesHtml(item);
    card.dataset.bssBadgesInjected = '1';
    if (!html) return;

    var title = card.querySelector('.boost-sd__product-title');
    if (!title) return;
    var container = document.createElement('div');
    container.innerHTML = html;
    var el = container.firstChild;
    title.parentNode.insertBefore(el, title);
  }

  function scan() {
    if (!feedLoaded) return;
    var cards = document.querySelectorAll('.boost-sd__product-item, .boost-sd__product-list-item');
    cards.forEach(injectBadges);
  }

  var scanScheduled = false;
  function scheduleScan() {
    if (scanScheduled) return;
    scanScheduled = true;
    requestAnimationFrame(function () {
      scanScheduled = false;
      scan();
    });
  }

  function init() {
    fetchFeed().then(scan);
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          scheduleScan();
          return;
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
